module.exports = {
  title: '用户子账号',
  route: {
    path: 'user-manage',
    children: {
      path: 'user-subaccount-list',
    },
  },
};
